import React from 'react';
import { defineMessages, IntlShape } from 'react-intl';

import neteeraLogo from '../resources/neteera-logo.svg';
import GenericCompanyLogo from '../resources/generic-company-logo.svg';
import CElogo from '../resources/conformite-europeene-logo.svg';
import USrepresentativeLogo from '../resources/US_representative.svg';
import IFUlogo from '../resources/ifu-logo.svg';
import { Col, Row } from 'antd';
import {
  StyledAboutFooter,
  StyledAboutHeader,
  StyledAboutWrapper,
  StyledImporterContainer,
} from './styled';
import { ABOUT_COMPANY_INFO, CONTINENTS, isEUContinent } from './constants';

export const AboutPopoverHeader = (continent: keyof typeof CONTINENTS) => (
  <StyledAboutHeader>
    <span>{ABOUT_COMPANY_INFO.aboutHeader[continent]}</span>
    <img src={neteeraLogo} />
  </StyledAboutHeader>
);

export const AboutPopoverContent = (
  intl: IntlShape,
  currentContinent: keyof typeof CONTINENTS,
) => (
  <StyledAboutWrapper>
    <Row gutter={[8, 32]}>
      <Col span={4}>
        <img src={GenericCompanyLogo} />
      </Col>
      <Col span={16}>
        <div>
          <p>{ABOUT_COMPANY_INFO.neteeraCompany[currentContinent]}</p>
          <p>{ABOUT_COMPANY_INFO.neteeraProfessor[currentContinent]}</p>
          <p>{ABOUT_COMPANY_INFO.neteeraAddress[currentContinent]}</p>
          <a href="https://www.neteera.com" target="_blank" rel="noreferrer">
            {ABOUT_COMPANY_INFO.neteeraStaticSite[currentContinent]}
          </a>
        </div>
      </Col>
    </Row>
    <br />
    <Row gutter={[8, 32]} align="middle">
      {!isEUContinent ? (
        <Col span={16}>
          <p>{ABOUT_COMPANY_INFO.importer[currentContinent]}</p>
          <p>{ABOUT_COMPANY_INFO.representativeCompany[currentContinent]}</p>
          <p>{ABOUT_COMPANY_INFO.representativeAddress[currentContinent]}</p>
          <p>
            {ABOUT_COMPANY_INFO.representativeCountryOrState[currentContinent]}
          </p>
          <p>
            {
              ABOUT_COMPANY_INFO.representativeCountryPhoneNumber[
                currentContinent
              ]
            }
          </p>
        </Col>
      ) : (
        <></>
      )}
      {isEUContinent ? (
        <StyledImporterContainer>
          <Col span={3}>
            <img src={CElogo} />
          </Col>
          <Col span={3}>
            <img src={IFUlogo} />
          </Col>
        </StyledImporterContainer>
      ) : (
        <Col span={4}>
          <img
            className="us-representative-styled"
            src={USrepresentativeLogo}
          />
        </Col>
      )}
    </Row>

    <div style={{ margin: '1rem 0' }}>
      <p>{ABOUT_COMPANY_INFO.neteeraCompanyName[currentContinent]}</p>
      <p>
        {intl.formatMessage(messages.version)}{' '}
        {ABOUT_COMPANY_INFO.neteeraAppVersion[currentContinent]}
      </p>
    </div>
    <p>
      {intl.formatMessage(messages.neteeraContactUs)}
      <a href="mailto: support@neteera.com">
        {ABOUT_COMPANY_INFO.neteeraContactMail[currentContinent]}
      </a>
    </p>

    <StyledAboutFooter>
      {ABOUT_COMPANY_INFO.aboutFooter[currentContinent]}
    </StyledAboutFooter>
  </StyledAboutWrapper>
);

const messages = defineMessages({
  neteeraContactUs: {
    id: 'AppLayout.AboutPopoverContent.neteeraContactUs',
    defaultMessage: 'Contact us at: ',
  },
  version: {
    id: 'AppLayout.AboutPopoverContent.version',
    defaultMessage: 'Version ',
  },
});
